const protocol = window.location.protocol
const qiniuHost = 'https://oic74zs8j.qnssl.com/'
const opapiHost = `${protocol}//mexicopay-api.pandafinance.co` //线上环境

export default {
    qiniuHost,
    opapiHost,
}



// WEBPACK FOOTER //
// ./src/config/production.config.js